// removed by extract-text-webpack-plugin
module.exports = {"button":"reviewer-controls__button___1hkl1","buttonsContainer":"reviewer-controls__buttonsContainer___oAaAw"};


//////////////////
// WEBPACK FOOTER
// ./study_reviewer/src/components/reviewers/reviewer-controls.css
// module id = 1214
// module chunks = 0